import { LoanInvestmentValues, LoanInvestmentResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// Profit = loanAmount * (dividendYield% - interest%) per year
export function calculateLoanInvestment(values: LoanInvestmentValues, t?: ToolsTranslations['loanInvestment']): LoanInvestmentResult {
  const { loanAmount, interestPercent, dividendYieldPercent } = values;
  if (loanAmount < 0 || interestPercent < 0 || dividendYieldPercent < 0) {
    return { profitPerYear: null, isValid: false, message: t?.invalid.generic };
  }
  const profit = loanAmount * ((dividendYieldPercent - interestPercent) / 100);
  const profitRounded = Math.round(profit);
  if (!isFinite(profitRounded)) return { profitPerYear: null, isValid: false, message: t?.invalid.generic };
  return { profitPerYear: profitRounded, isValid: true };
}


